/**
 * Convercus ↔ Braze
 * Webhook endpoints exposed to Braze, forwarding to Convercus REST API
 *
 * The version of the OpenAPI document: 1.0.34910
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateEmailSubscriptionDto { 
    /**
     * Convercus account ID of the member
     */
    account_id: string;
    /**
     * Subscription status to apply to the opt-in channels
     */
    status: UpdateEmailSubscriptionDto.StatusEnum;
    /**
     * Opt-in channels to apply the status to. Overrides BrazeConfig.defaultOptins when present.
     */
    optins?: Array<string>;
}
export namespace UpdateEmailSubscriptionDto {
    export type StatusEnum = 'allowed' | 'declined';
    export const StatusEnum = {
        Allowed: 'allowed' as StatusEnum,
        Declined: 'declined' as StatusEnum
    };
}


